import * as React from 'react';
import cx from 'classnames';
import CountrySelect from '../country-select/CountrySelect';
import { FacebookIcon, LinkedInIcon } from '../icons/index';
import ContentContainer from '../content-container/ContentContainer';
import { AnalyticsConsumer } from '../../providers/AnalyticsProvider';
import styles from './BottomNavigation.module.scss';

const BottomNavigation = () => (
  <section className={styles.root}>
    <ContentContainer with="normal">
      <div className={styles.layout}>
        <div className={cx(styles.col, styles.col_wide)}>
          <div className={styles.countryHolder}>
            <h4 className={styles.title}>Country</h4>
            <CountrySelect />
          </div>

          <AnalyticsConsumer category="social_media">
            {({ sendAction, dataProps }) => (
              <>
                <div className={styles.accountsContainer}>
                  <div className={styles.socialHolder}>
                    <a
                      className={styles.socialLink}
                      href="https://www.facebook.com/flatfy"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => sendAction('fb')}
                      {...dataProps}
                    >
                      <FacebookIcon />
                    </a>
                  </div>
                  <div className={styles.socialHolder}>
                    <a
                      className={styles.socialLink}
                      href="https://www.linkedin.com/company/flatfycom/about"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => sendAction('in')}
                      {...dataProps}
                    >
                      <LinkedInIcon />
                    </a>
                  </div>
                </div>
              </>
            )}
          </AnalyticsConsumer>
        </div>

        {/* <div className={styles.col}>
          <h4 className={styles.title}>Products</h4>
          <div className={styles.linksHolder}>
            <a
              className={styles.link}
              href="https://flatfy.in/media-kit"
              target="_blank"
              rel="noopener noreferrer"
            >
              New Construction
            </a>
            <a
              className={styles.link}
              href="https://flatfy.in/terms-of-use"
              target="_blank"
              rel="noopener noreferrer"
            >
              Neighbors
            </a>
          </div>
        </div> */}

        <div className={styles.col}>
          <h4 className={styles.title}>Resources</h4>
          <div className={styles.linksHolder}>
            <a
              className={styles.link}
              href="https://flatfy.in/media-kit"
              target="_blank"
              rel="noopener noreferrer"
            >
              Media Kit
            </a>
            <a
              className={styles.link}
              href="https://flatfy.com/terms-of-use"
              target="_blank"
              rel="noopener noreferrer"
            >
              Term of Use
            </a>
            <a
              className={styles.link}
              href="https://flatfy.com/cookies"
              target="_blank"
              rel="noopener noreferrer"
            >
              Cookie Policy
            </a>
            <a
              className={styles.link}
              href="https://flatfy.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </div>
        </div>

        {/* <div className={styles.col}>
          <h4 className={styles.title}>Support</h4>
          <div className={styles.linksHolder}>
            <a
              className={styles.link}
              href="https://flatfy.in/media-kit"
              target="_blank"
              rel="noopener noreferrer"
            >
              Сontact
            </a>
            <a
              className={styles.link}
              href="https://flatfy.in/terms-of-use"
              target="_blank"
              rel="noopener noreferrer"
            >
              Place an ad
            </a>
            <a
              className={styles.link}
              href="https://flatfy.in/cookies"
              target="_blank"
              rel="noopener noreferrer"
            >
              Partnership
            </a>
          </div>
        </div> */}
      </div>
    </ContentContainer>
  </section>
);

export default BottomNavigation;
